import {type ChannelCategoryType} from 'mattermost-redux/types/channel_categories';

export const CategoryTypes = {
    FAVORITES: 'favorites',
    CHANNELS: 'channels',
    DIRECT_MESSAGES: 'direct_messages',
    CUSTOM: 'custom',
} as const satisfies Record<string, ChannelCategoryType>;
